<mat-card *ngIf="data">
    <mat-card-content>
      <h2 class="mb-0 info-title">{{data.title}}</h2>
      <div class="info-description">
        {{data.description}}
      </div>
  
      <div class="services-links">
        <a *ngFor="let link of data.links" [target]="link.target" [href]="link.url" class="service-link">
          <span class="link-text">{{link.title}}</span>
          <mat-icon [svgIcon]="'next-2'" class="square-icon link-icon"></mat-icon>
        </a>
      </div>
    </mat-card-content>
</mat-card>